import {REGION_KEYS} from '~/assets/js/constants'

export function getRegionForSalesArea(SalesArea) {
  if (SalesArea === '0056-99-99' || SalesArea === '0047-99-99' || SalesArea === '0056-04-99' || SalesArea === '0049-99-99') {
    return REGION_KEYS.NA
  }
  return REGION_KEYS.EU
}
